/**
 * Parseia os dados de consolidações configurados pelo usuário para um formato esperado
 * no endpoint e retorna ele.
 * @param {Array<object>} creates
 * @param {Array<object>} updates
 * @param {Array<object>} deletes
 */

export default function getParsedPayload(creates, updates, deletes) {
  return {
    creates: creates.map((cons) => ({
      legenda: cons.title,
      alternativas: cons.alternatives.map(({ value, label }) => ({
        id: value,
        enunciado: label,
      })),
    })),
    updates: updates.map((cons) => ({
      id_configuracao: cons.value,
      legenda: cons.title,
      alternativas: cons.alternatives.map(({ value, label }) => ({
        id: value,
        enunciado: label,
      })),
    })),
    updatesByTitle: updates
      .filter((cons) => cons.oldTitle !== undefined)
      .map((cons) => ({ oldLegenda: cons.oldTitle, legenda: cons.title })),
    deletes: deletes.map(({ value, title }) => ({ value, legenda: title })),
  };
}
